import { render } from "./MyCollapse.vue?vue&type=template&id=bfcac1da&scoped=true"
import script from "./MyCollapse.vue?vue&type=script&lang=js"
export * from "./MyCollapse.vue?vue&type=script&lang=js"

import "./MyCollapse.vue?vue&type=style&index=0&id=bfcac1da&lang=less&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/PROD/okr-web-next/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfcac1da"]])

export default __exports__